import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Notes } from '@app/core/Enum/note';
import { CommonService } from '@app/core/Services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-note25',
  templateUrl: './note25.component.html',
  styleUrls: ['./note25.component.scss'],
})
export class Note25Component implements OnInit {
  note25Form: FormGroup;
  calculativeData: any;
  @Input() triggerEditData: Observable<any>;

  constructor(public commonService: CommonService) {}
  ngOnInit(): void {
    this.setForm();
    this.triggerEditData?.subscribe((data) => {
      if (data.noteId === Notes.Note25) {
        this.calculativeData = data.response.calculativeData;
        if (
          data.response.userInputData !== null &&
          data.response.userInputData !== undefined &&
          data.response.userInputData.data !== null &&
          data.response.userInputData.data !== undefined
        ) {
          this.editNotes25(data.response.userInputData.data);
        }
      }
    });
  }

  editNotes25(res): void {
    this.note25Form.patchValue({
      textbox1: res.textbox1 ? res.textbox1 : ' ',
      textbox2: res.textbox2 ? res.textbox2 : ' ',
      textbox3: res.textbox3 ? res.textbox3 : ' ',
    });
  }

  setForm(): void {
    this.note25Form = new FormGroup({
      textbox1: new FormControl(''),
      textbox2: new FormControl(''),
      textbox3: new FormControl(''),
    });
  }
}
